<template>
  <component
    :is="to ? RouterLink : 'button'"
    :to="to"
    :type="to ? undefined : 'button'"
    :disabled="!to && disabled || undefined"
    class="app-navigation-item"
    :aria-current="active ? 'page' : undefined"
    :aria-disabled="disabled || undefined"
  >
    <i v-if="icon" :class="['app-navigation-item__icon', 'zmdi', icon]" aria-hidden="true" />
    <span class="app-navigation-item__label" :class="{ 'interior-highlight': active }">{{ label }}</span>
    <slot />
  </component>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'

defineProps<{ label: string; to?: string; active?: boolean; disabled?: boolean; icon?: string }>()
</script>

<style scoped lang="scss">
.app-navigation-item {
  // One state on every page, including the flow-specific palette.
  background: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
  color: var(--ds-text) !important;
  text-decoration: none;

  &__label { line-height: 1.5; }
  &__icon { font-size: 22px; line-height: 1; }
  &:hover:not(:disabled) .app-navigation-item__label { text-decoration: underline; text-underline-offset: .2em; }
  &[aria-disabled='true'] { opacity: .5; cursor: default; }
}
</style>
